import { ReactNode } from "react";
import "./index.css";

const SPEEDYCORE_PLATFORM_SITES: ReadonlyArray<{
  href: string;
  label: string;
  primary?: boolean;
}> = [
  { href: "https://speedycore.com.au/", label: "SpeedyCore", primary: true },
  { href: "https://constructiveos.com.au/", label: "Constructive OS" },
  { href: "https://mytradieweb.com.au/", label: "MyTradieWeb" },
  { href: "https://creatorshub.com.au/", label: "CreatorHub" },
  { href: "https://hubcircles.com.au/", label: "HubCircles" },
  { href: "https://adverthub.com.au/", label: "AdvertHub" },
  { href: "https://pluginfactoryai.com/", label: "Plugin Factory" },
  { href: "https://dashboard.speedycore.com.au/", label: "Dashboard" },
  { href: "https://ide.speedycore.com.au/", label: "IDE" },
];

export interface IdentityLayoutProps {
  header?: ReactNode;
  hero?: ReactNode;
  form?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
}

export function IdentityLayout({ header, hero, form, footer, children }: IdentityLayoutProps) {
  return (
    <div className="sc-identity-layout">
      <div className="sc-identity-domainband" role="navigation" aria-label="SpeedyCore platform sites">
        <div className="sc-identity-domainband__inner">
          <span className="sc-identity-domainband__label" aria-hidden="true">
            Platform sites →
          </span>
          <div className="sc-identity-domainband__links">
            {SPEEDYCORE_PLATFORM_SITES.map((s) => (
              <a
                key={s.href}
                href={s.href}
                className={
                  "sc-identity-domainband__link" +
                  (s.primary ? " sc-identity-domainband__link--primary" : "")
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {s.label}
              </a>
            ))}
          </div>
        </div>
      </div>
      {header ? <div className="sc-identity-top">{header}</div> : null}
      <main className="sc-identity-main">
        <div className="sc-identity-column">
          <div className="sc-identity-container">
            <div className="sc-identity-card">
              {hero ? <div style={{ marginBottom: "1.25rem" }}>{hero}</div> : null}
              {form}
              {children}
            </div>
          </div>
        </div>
      </main>
      {footer}
    </div>
  );
}
